import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { UtilityProvider } from 'app/providers/utility/utility'
import { RestWS } from 'app/services/restService';
import { locale as english } from './i18n/en'
import { locale as spanish } from './i18n/es';
import { ActivatedRoute } from '@angular/router';





@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})



export class ForgotPasswordComponent implements OnInit {
    forgotPasswordForm: FormGroup;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private utils: UtilityProvider,
        private translate: TranslateService,
        private api: RestWS,
        private route: ActivatedRoute
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

        
    }


    email: string = '';
    link: string = '';
    new_password: string = '';
    confirm_password: string = '';
   


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this.forgotPasswordForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });

      
       

    }


    onSubmit() {
        this.api.crearLink(this.email).then( result => {
            if (result.status === 'bad') {
                if (result.code == 1) {
                    this.utils.openDialog(this.utils.WARNING, 'El correo especificado no se encuentra registrado. Por favor, verifique que está escrito correctamente: ' + this.email, false, false);
                } else if (result.code == 2) {
                    this.utils.openDialog(this.utils.WARNING, 'Esta operación no está disponible para su usuario. Por favor, contacte con su proveedor.' + this.email, false, false);
                } else if (result.code == 3) {
                    this.utils.openDialog(this.utils.ERROR, 'Ha ocurrido un error al realizar el envío a su correo electrónico. Por favor, inténtelo de nuevo más tarde.', false, false);
                }
            } else {
                this.utils.openDialog(this.utils.SUCCESS, 'Se ha enviado correo de recuperación a: ' + this.email, false, false);
  
            }
        })
     
    }

   

}